import styled from 'styled-components'

export const BoxCupom = styled.div`
  width: 100%;
  height: 54px;
  position: relative;
  top: 0;
  z-index: 90;

  @media (max-width: 1200px) {
    height: 0;
    padding-top: 13.07%;
  }

  @media (max-width: 375px) {
    height: 49px;
    padding-top: 0;
  }
`
